import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        container: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 2,

        },
        dropdown: {
            position: 'absolute',
            left: 46,
            minWidth: 210,
            color: theme.palette.common.white,
            zIndex: 3,
            '& :last-child div': {
                display: 'none',
            },
            '@media print': {
                display: 'none',
            },
        },
        linkContainer: {
            position: 'relative',
            marginLeft: 2,
            height: '50px',
            display: 'flex',
            background: theme.palette.primary[800],
            '&:hover': {
                backgroundColor: theme.palette.primary[1000],
            },
        },
        linkLabel: {
            color: `${theme.palette.common.white} !important`,
        },
        link: {
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            fontWeight: 400,
            paddingLeft: theme.spacing(1.25),
            whiteSpace: 'nowrap',
            flex: 1,
        },
        underline: {
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderBottom: `1px solid ${theme.palette.primary[1000]}`,
        },
    }
})

export default useStyles
